<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" />
    <p>welcome</p>
  </div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>
